import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/index.scss'
import 'amfe-flexible' // rem 布局适配
var VueTouch = require('vue-touch')
import { Toast } from 'vant';
import 'vant/es/toast/style';

const app = createApp(App)
app.use(Toast)
app.use((VueTouch, { name: 'v-touch' })).use(store).use(router).mount('#app')


// 定义全局方法
const showLoading = (text) => {
    Toast.loading({
        message: text || "加载中",
        duration: 0,
    });
}
const hideLoading = () => {
    Toast.clear()
}

// 挂载全局方法
app.config.globalProperties.showLoading = showLoading
app.config.globalProperties.hideLoading = hideLoading